import axios from "axios";
import Config from "../utils/Config";

class CompanyService {
    config = {
        headers: {
          Authorization: "",
          GroupId: "",
          CompanyId: "",
        },
      };
    
      setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
      }

      //create company
      async createCompany (accessToken, groupId, companyId, formData){
        this.setAccessToken(accessToken, groupId, companyId);
    
        const data = await axios.post(
            Config.BACKEND_URL + "/api/company", //api/company
            formData,
            this.config
          )
          return data.data;
      }

      //update company
      async updateCompany (accessToken, groupId, companyId, id, formData){
        this.setAccessToken(accessToken, groupId, companyId);
        
        const data = await axios.patch(
            Config.BACKEND_URL + `/api/company/${id}`, //api/company/:id
            formData,
            this.config
          )
          return data.data;
      }

      //get company by id
    async getCompanyById (accessToken, groupId, companyId, id){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + `/api/company/${id}`, //api/company/:id
                this.config
            )
            return data.data;
        }

    //get companies for logged user
    async getCompaniesForLoggedUser (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
        const sanitizedGroupId = groupId || '';
        const sanitizedCompanyId = companyId || '';
            const data = await axios.get(
                Config.BACKEND_URL + `/api/company/getCompaniesForLoggedUser?groupId=${sanitizedGroupId}&companyId=${sanitizedCompanyId}`, //api/user/getMembersForLoggedUser?
                this.config
            )
            return data.data;
        }

      //get my company
      async getMyCompany (accessToken, groupId, companyId){
        console.log("API level grp company",groupId ,companyId)
        console.log("API level token ",accessToken)
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + `/api/company/getMyCompany`, //api/company/getMyCompany
                this.config
            )
            return data.data;
        }

       //get classification codes 
      async GetcompanyClassificationCodes (accessToken, groupId, companyId)
      {
        this.setAccessToken(accessToken,groupId,companyId);
        const data = await axios.get(
          Config.BACKEND_URL + `/api/company/companyClassificationCodes`, 
          this.config
        )
        return data.data;

      }

    // get country codes
    async getCountryCodes (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + "/api/data/country-codes", //api/data/country-codes
                this.config
            )
            return data.data;
        }

    // get state codes
      async getStateCodes (accessToken, groupId, companyId){
          this.setAccessToken(accessToken, groupId, companyId);
              const data = await axios.get(
                  Config.BACKEND_URL + "/api/data/state-codes", //api/data/state-codes
                  this.config
              )
              return data.data;
          }

    // get parent companies for logged user
    async getParentCompaniesForLoggedUser (accessToken, groupId, companyId){
      this.setAccessToken(accessToken, groupId, companyId);
      const sanitizedGroupId = groupId || '';
      const sanitizedCompanyId = companyId || '';
          const data = await axios.get(
              Config.BACKEND_URL + `/api/company/parentCompanies?groupId=${sanitizedGroupId}&companyId=${sanitizedCompanyId}`, //api/user/getMembersForLoggedUser?
              this.config
          )
          return data.data;
    }

    
}

export default new CompanyService();